import { Fragment } from 'react';

export const Highlight = ({ text, query }: { text: string; query: string }) => {
  const needle = query.trim().toLowerCase();
  if (!needle) return <>{text}</>;

  const pieces: { text: string; hit: boolean }[] = [];
  let rest = text;

  while (rest) {
    const at = rest.toLowerCase().indexOf(needle);
    if (at < 0) {
      pieces.push({ text: rest, hit: false });
      break;
    }
    if (at > 0) pieces.push({ text: rest.slice(0, at), hit: false });
    pieces.push({ text: rest.slice(at, at + needle.length), hit: true });
    rest = rest.slice(at + needle.length);
  }

  return (
    <>
      {pieces.map((piece, index) => (
        <Fragment key={index}>
          {piece.hit ? (
            <span className="rounded-check bg-border-strong px-hair text-primary">
              {piece.text}
            </span>
          ) : (
            piece.text
          )}
        </Fragment>
      ))}
    </>
  );
};
